import React, { useState } from 'react';
import {
    TableCell,
    Typography,
    TableRow,
    Collapse,
    Card
} from '@mui/material';
import CRoleDHistoryChildTable from './cRoleDHistoryChildTable';
import ActionButtons from '../../admin/dashboard/actionButtons';


const DeliveryHistoryTableRow = ({ rowData, index, handleRequestSort, order,orderBy }) => {

    const [expandOpen, setExpandOpen] = useState(false);
    const [status, setStatus] = useState('list');

    return (
        <>
            <TableRow
                hover
                tabIndex={-1}
            >
                {/* <TableCell align="left" sx={{ width: '100px' }}>
                    <Typography variant='t14_600'>
                        {rowData["nBookingID"]}
                    </Typography>
                </TableCell>
                <TableCell align="left" sx={{ width: '200px' }}>
                    <Typography variant='t14_600'>
                        {rowData["Contractor ID"]}
                    </Typography>
                </TableCell> */}
                <TableCell align="left" sx={{ width: '200px' }}>
                    <Typography variant='t14_600'>
                        {rowData["Contractor Name"]}
                    </Typography>
                </TableCell>
                <TableCell align="left" sx={{ width: '180px' }}>
                    <Typography variant='t14_600'>
                        {rowData.MealName}
                    </Typography>
                </TableCell>
                {/* <TableCell align="left" sx={{ width: '130px' }}>
                    <Typography variant='t14_600'>
                        {rowData["Menu Name"]}
                    </Typography>
                </TableCell> */}
                <TableCell align="left" sx={{ width: '180px' }}>
                    <Typography variant='t14_600'>
                        {rowData.OrderDate}
                    </Typography>
                </TableCell>
                <TableCell align="left" sx={{ width: '180px' }}>
                    <Typography variant='t14_600'>
                        {rowData.Quantity}
                    </Typography>
                </TableCell>
                <TableCell align="left" sx={{ width: '180px' }}>
                    <Typography variant='t14_600'>
                        {rowData.Swiped}
                    </Typography>
                </TableCell>
                <TableCell align="left" sx={{ width: '170px' }}>
                    <Typography variant='t14_600'>
                        {rowData.UnSwiped}
                    </Typography>
                </TableCell>
                {/* <TableCell align="center" sx={{ width: '10px' }}>
                    <Typography variant='t14_600'>
                        {rowData.Rate}
                    </Typography>
                </TableCell>
                <TableCell align="center" sx={{ width: '10px' }}>
                    <Typography variant='t14_600'>
                        {rowData["Total Rate"]}
                    </Typography>
                </TableCell> */}
                <TableCell align="left" sx={{ width: '170px' }}>
                    <Typography variant='t14_600'>
                        {rowData.Status}
                    </Typography>
                </TableCell>
                {/* <TableCell align="left" sx={{ width: '50px' }}>
                    <Typography variant='t14_600'>
                        {rowData.Cafeteria}
                    </Typography>
                </TableCell> */}
                <TableCell align="right" sx={{ width: '100px' }}>
                <ActionButtons status={status} setStatus={setStatus} expandOpen={expandOpen} setExpandOpen={setExpandOpen} type={'cRoleDeliveryHistory'}/>
                </TableCell>
            </TableRow>

            <TableRow>
                <TableCell colSpan={12} style={{ padding: 0 }}>
                    <Collapse in={expandOpen} timeout="auto" unmountOnExit>
                        <Card sx={{ bgcolor: 'grey.200' }} >
                            <CRoleDHistoryChildTable expandOpen={expandOpen} rowData={rowData} handleRequestSort={handleRequestSort} orderBy={orderBy} order={order} status={status} />
                        </Card>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    )
}

export default DeliveryHistoryTableRow